export const COOKIE_CONSENT_STORAGE_KEY = 'proka_cookie_consent_accepted'

export function hasAcceptedCookieConsent(): boolean {
  try {
    return localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export function acceptCookieConsent(): void {
  try {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, '1')
  } catch {
    // ignore quota / private mode
  }
}
